<template>
  <div v-if="!maintenanceModeEnabled" class="login">
    <div class="panel">
      <div class="shopify-logo"></div>
      <shopify-login/>
    </div>
    <!-- <div class="or">ou</div>
    <div class="panel">
      <div class="geometric-logo" sgt></div>
      <email-login/>
    </div> -->
  </div>
</template>

<script>
import ShopifyLogin from '../../components/auth/ShopifyLogin'
// import EmailLogin from '../../components/auth/EmailLogin'

export default {
  name: 'shopify-email-login',
  components: {
    ShopifyLogin
    // EmailLogin
  },
  data () {
    return {
      maintenanceModeEnabled: false
    }
  }
}
</script>

<style lang="scss">
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    .shopify-logo {
      width: 200px;
      height: 100px;
      border: none;
      background-size: 200px;
      background-repeat: no-repeat;
      background-image: url('../../assets/Logo/shopify_logo_whitebg.svg');
      margin: 0px;
    }
    .geometric-logo {
      width: 200px;
      height: 80px;
      border: none;
      background-size: 200px;
      background-repeat: no-repeat;
      background-image: url('../../assets/icons/Logo/Logo/geometric.svg');
      margin: 0px;
    }
  }
  .or {
    padding:40px;
    font-size: 24px;
    font-family: 'geomanist-medium'
  }
}
</style>
